import "./ball-variants.css"

interface BallVariant {
	className: string
	id: string
	logic: string
	name: string
}

// 10 two-color pattern treatments. Each pattern owns its two colors in CSS
// (--cva / --cvb) so the hue pool stays small and variety comes from the
// treatment, not from adding more colors.
const VARIANTS: readonly BallVariant[] = [
	{ className: "bv--cross", id: "cross", logic: "criss-cross lattice the ball", name: "Criss-cross" },
	{ className: "bv--cluster", id: "cluster", logic: "cluster of small balls", name: "Cluster" },
	{ className: "bv--split", id: "split", logic: "vertical halves, 50/50", name: "Split halves" },
	{ className: "bv--split-diag", id: "split-diag", logic: "diagonal halves, 50/50", name: "Diagonal split" },
	{ className: "bv--quad", id: "quad", logic: "four alternating wedges", name: "Quadrants" },
	{ className: "bv--rings", id: "rings", logic: "concentric rings", name: "Rings" },
	{ className: "bv--checker", id: "checker", logic: "checkerboard squares", name: "Checkerboard" },
	{ className: "bv--vstripes", id: "vstripes", logic: "vertical stripes", name: "Vertical stripes" },
	{ className: "bv--hstripes", id: "hstripes", logic: "horizontal stripes", name: "Horizontal stripes" },
	{ className: "bv--spiral", id: "spiral", logic: "spiral / pinwheel", name: "Spiral" },
]

const ballClassNames = (className: string): string=> `bv-ball ${className}`

export function BallVariants() {
	return (
		<section aria-label="Two-color pattern balls" className="bv">
			<h2 className="text-xl font-bold">
				Ball variants — {VARIANTS.length} two-color patterns over 4 pooled hues
			</h2>
			<p className="">
				Every ball uses exactly 2 colors, close to equally; only a small pool
				of hues exists, reshaped by pattern instead of by adding colors.
			</p>
			<div className="bv-grid">
				{VARIANTS.map(({ className, id, logic, name })=> (
					<figure className="bv-card" key={id}>
						<div className="bv-stage">
							<span aria-hidden="true" className={ballClassNames(className)} />
						</div>
						<figcaption className="bv-caption">
							<strong>{name}</strong>
							<code>{logic}</code>
						</figcaption>
					</figure>
				))}
			</div>
		</section>
	)
}
